import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Package, Plus, TrendingUp, Menu, X, Upload, Sparkles, FileText, Zap } from 'lucide-react';

const navItems = [
  { path: '/home', icon: Home, label: 'Home' },
  { path: '/my-products', icon: Package, label: 'Products' },
  { path: '__add__', icon: Plus, label: 'Add', isAction: true },
  { path: '/growth', icon: TrendingUp, label: 'Growth' },
  { path: '/more', icon: Menu, label: 'More' },
];

export const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showAdd, setShowAdd] = useState(false);

  const handleClick = (item) => {
    if (item.isAction) {
      setShowAdd(true);
    } else {
      navigate(item.path);
    }
  };

  const isActive = (path) => {
    if (path === '/home') return location.pathname === '/home' || location.pathname === '/';
    if (path === '/my-products') return location.pathname.startsWith('/my-products') || location.pathname.startsWith('/product/') || location.pathname.startsWith('/content-studio/') || location.pathname.startsWith('/visual-commerce/');
    if (path === '/growth') return location.pathname.startsWith('/growth');
    if (path === '/more') return location.pathname.startsWith('/more') || location.pathname === '/brand-brain';
    return location.pathname === path;
  };

  return (
    <>
      {/* Add Action Sheet */}
      {showAdd && (
        <div className="fixed inset-0 z-[60] flex items-end justify-center" onClick={() => setShowAdd(false)}>
          <div className="absolute inset-0 bg-black/30" />
          <div className="relative w-full max-w-md bg-white rounded-t-2xl p-4 pb-8 space-y-2 animate-in slide-in-from-bottom" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-base font-bold text-slate-800">What would you like to create?</h3>
              <button onClick={() => setShowAdd(false)}><X size={20} className="text-gray-400" /></button>
            </div>
            {[
              { icon: Upload, label: 'Add Product', desc: 'Upload a product and generate AI content', route: '/upload', color: 'bg-[#128C7E]' },
              { icon: Sparkles, label: 'Create Visual', desc: 'Generate AI product photography', route: '/my-products', color: 'bg-purple-600' },
              { icon: FileText, label: 'Create Content', desc: 'Generate marketing content', route: '/my-products', color: 'bg-blue-600' },
              { icon: Zap, label: 'Growth Action', desc: 'Take your top growth recommendation', route: '/growth', color: 'bg-amber-600' },
            ].map(a => (
              <button key={a.label} onClick={() => { setShowAdd(false); navigate(a.route); }}
                className="w-full flex items-center gap-3 p-3 rounded-xl border border-gray-100 active:bg-gray-50 transition-colors text-left"
                data-testid={`add-${a.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                <div className={`w-10 h-10 ${a.color} rounded-lg flex items-center justify-center text-white`}><a.icon size={18} /></div>
                <div>
                  <p className="text-sm font-semibold text-slate-800">{a.label}</p>
                  <p className="text-[10px] text-gray-500">{a.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Bottom Nav Bar */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 max-w-md mx-auto" data-testid="bottom-nav">
        <div className="flex items-center justify-around py-1.5">
          {navItems.map((item) => {
            const active = !item.isAction && isActive(item.path);
            return (
              <button key={item.path} onClick={() => handleClick(item)}
                className={`flex flex-col items-center gap-0.5 px-3 py-1 rounded-lg transition-colors relative ${
                  item.isAction ? '' : active ? 'text-[#128C7E]' : 'text-gray-400'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.isAction ? (
                  <div className="w-12 h-12 bg-[#128C7E] rounded-full flex items-center justify-center -mt-5 shadow-lg border-4 border-white">
                    <Plus size={24} className="text-white" />
                  </div>
                ) : (
                  <>
                    <item.icon size={20} strokeWidth={active ? 2.5 : 1.5} />
                    <span className={`text-[10px] ${active ? 'font-bold' : 'font-medium'}`}>{item.label}</span>
                  </>
                )}
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};
